/** Auto-generated from design/buildconstrux — see docs/BUILDCONSTRUX_PORTFOLIO.md */
const buildconstruxCatalog = {
  "source": "WFDownloader buildconstrux Webflow media",
  "asset_count": 58,
  "categories": {
    "assembly-guides": 2,
    "brand-logo": 2,
    "factory-shop": 4,
    "finished-structure": 2,
    "jobsite-foundation": 1,
    "jobsite-framing": 14,
    "marketing-graphics": 6,
    "panel-assembly": 3,
    "people-spokesperson": 6,
    "press-events": 4,
    "product-renders": 10,
    "site-context": 2,
    "stock-broll": 2
  },
  "mediaBase": "/media/buildconstrux",
  "assets": [
    {
      "id": "C-Bnbl-gtUi",
      "category": "press-events",
      "slug": "fox-news-plaza-booth-host",
      "format": "video",
      "orientation": "vertical",
      "description": "Fox News plaza Construx OSB booth with host",
      "tags": [
        "fox-news",
        "booth",
        "osb"
      ],
      "confidence": 95,
      "thumb": "C-Bnbl-gtUi_cover.jpg",
      "media": [
        "C-Bnbl-gtUi.mp4"
      ],
      "files": [
        "C-Bnbl-gtUi.mp4",
        "C-Bnbl-gtUi_cover.jpg"
      ]
    },
    {
      "id": "C2-HxrHLwap",
      "category": "marketing-graphics",
      "slug": "website-construction-reimagined",
      "format": "still",
      "orientation": "portrait",
      "description": "Legacy site screenshot Construction Reimagined",
      "tags": [
        "ui",
        "website"
      ],
      "confidence": 98,
      "thumb": "C2-HxrHLwap.jpg",
      "media": [
        "C2-HxrHLwap.jpg"
      ],
      "files": [
        "C2-HxrHLwap.jpg"
      ]
    },
    {
      "id": "C29xs8LumTx",
      "category": "jobsite-framing",
      "slug": "looking-up-engineered-beams",
      "format": "video",
      "orientation": "vertical",
      "description": "Low-angle engineered wood framing with worker",
      "tags": [
        "lvl",
        "framing"
      ],
      "confidence": 95,
      "thumb": "C29xs8LumTx_cover.jpg",
      "media": [
        "C29xs8LumTx.mp4"
      ],
      "files": [
        "C29xs8LumTx.mp4",
        "C29xs8LumTx_cover.jpg"
      ]
    },
    {
      "id": "C2HxrheOEwm",
      "category": "stock-broll",
      "slug": "mlk-march-on-washington",
      "format": "video",
      "orientation": "landscape",
      "description": "MLK March on Washington historical stock clip",
      "tags": [
        "historical",
        "stock"
      ],
      "confidence": 99,
      "thumb": "C2HxrheOEwm_cover.jpg",
      "media": [
        "C2HxrheOEwm.mp4"
      ],
      "files": [
        "C2HxrheOEwm.mp4",
        "C2HxrheOEwm_cover.jpg"
      ]
    },
    {
      "id": "C2KYfoQueJQ",
      "category": "product-renders",
      "slug": "isometric-gable-frames",
      "format": "video",
      "orientation": "landscape",
      "description": "CGI isometric wooden gable frame row with logo",
      "tags": [
        "cgi",
        "truss"
      ],
      "confidence": 98,
      "thumb": "C2KYfoQueJQ_cover.jpg",
      "media": [
        "C2KYfoQueJQ.mp4"
      ],
      "files": [
        "C2KYfoQueJQ.mp4",
        "C2KYfoQueJQ_cover.jpg"
      ]
    },
    {
      "id": "C2PlfU1u9GA",
      "category": "jobsite-framing",
      "slug": "stairwell-rough-framing",
      "format": "video",
      "orientation": "vertical",
      "description": "Interior stairwell rough framing AdvanTech codes",
      "tags": [
        "stairs",
        "advanTech"
      ],
      "confidence": 96,
      "thumb": "C2PlfU1u9GA_cover.jpg",
      "media": [
        "C2PlfU1u9GA.mp4"
      ],
      "files": [
        "C2PlfU1u9GA.mp4",
        "C2PlfU1u9GA_cover.jpg"
      ]
    },
    {
      "id": "C2cdaKGunBa",
      "category": "factory-shop",
      "slug": "warehouse-forklift",
      "format": "video",
      "orientation": "vertical",
      "description": "Industrial forklift on factory floor",
      "tags": [
        "forklift",
        "warehouse"
      ],
      "confidence": 97,
      "thumb": "C2cdaKGunBa_cover.jpg",
      "media": [
        "C2cdaKGunBa.mp4"
      ],
      "files": [
        "C2cdaKGunBa.mp4",
        "C2cdaKGunBa_cover.jpg"
      ]
    },
    {
      "id": "C2m4uLVOCA0",
      "category": "jobsite-foundation",
      "slug": "floor-beams-on-piers",
      "format": "video",
      "orientation": "vertical",
      "description": "Floor beam framing on adjustable metal piers",
      "tags": [
        "foundation",
        "piers"
      ],
      "confidence": 97,
      "thumb": "C2m4uLVOCA0_cover.jpg",
      "media": [
        "C2m4uLVOCA0.mp4"
      ],
      "files": [
        "C2m4uLVOCA0.mp4",
        "C2m4uLVOCA0_cover.jpg"
      ]
    },
    {
      "id": "C2sZlPCRmGN",
      "category": "panel-assembly",
      "slug": "crane-lift-insulated-panel",
      "format": "video",
      "orientation": "vertical",
      "description": "Crane lifting insulated panel onto OSB wall",
      "tags": [
        "crane",
        "insulation",
        "advanTech"
      ],
      "confidence": 97,
      "thumb": "C2sZlPCRmGN_cover.jpg",
      "media": [
        "C2sZlPCRmGN.mp4"
      ],
      "files": [
        "C2sZlPCRmGN.mp4",
        "C2sZlPCRmGN_cover.jpg"
      ]
    },
    {
      "id": "C4p-d8mrztu",
      "category": "marketing-graphics",
      "slug": "we-build-frames-flyer",
      "format": "gallery",
      "orientation": "portrait",
      "description": "WE BUILD FRAMES / FASTER marketing flyer set",
      "tags": [
        "flyer",
        "gallery"
      ],
      "confidence": 99,
      "thumb": "C4p-d8mrztu_1.jpg",
      "media": [
        "C4p-d8mrztu_1.jpg",
        "C4p-d8mrztu_2.jpg",
        "C4p-d8mrztu_3.jpg",
        "C4p-d8mrztu_4.jpg",
        "C4p-d8mrztu_5.jpg",
        "C4p-d8mrztu_6.jpg",
        "C4p-d8mrztu_7.jpg"
      ],
      "files": [
        "C4p-d8mrztu_1.jpg",
        "C4p-d8mrztu_2.jpg",
        "C4p-d8mrztu_3.jpg",
        "C4p-d8mrztu_4.jpg",
        "C4p-d8mrztu_5.jpg",
        "C4p-d8mrztu_6.jpg",
        "C4p-d8mrztu_7.jpg"
      ]
    },
    {
      "id": "C57RknHLrgU",
      "category": "press-events",
      "slug": "urban-alley-construx-display",
      "format": "video",
      "orientation": "vertical",
      "description": "Outdoor Construx framed display between brick buildings",
      "tags": [
        "booth",
        "display"
      ],
      "confidence": 90,
      "thumb": "C57RknHLrgU_cover.jpg",
      "media": [
        "C57RknHLrgU.mp4"
      ],
      "files": [
        "C57RknHLrgU.mp4",
        "C57RknHLrgU_cover.jpg"
      ]
    },
    {
      "id": "C6CmLv4RR6F",
      "category": "brand-logo",
      "slug": "co-wordmark-fragment",
      "format": "video",
      "orientation": "landscape",
      "description": "Large CO wordmark fragment on white (logo motion)",
      "tags": [
        "typography",
        "logo"
      ],
      "confidence": 88,
      "thumb": "C6CmLv4RR6F_cover.jpg",
      "media": [
        "C6CmLv4RR6F.mp4"
      ],
      "files": [
        "C6CmLv4RR6F.mp4",
        "C6CmLv4RR6F_cover.jpg"
      ]
    },
    {
      "id": "C6WqnwxRU3c",
      "category": "jobsite-framing",
      "slug": "attic-advantech-interior",
      "format": "video",
      "orientation": "landscape",
      "description": "Attic/upper-floor AdvanTech panelized interior",
      "tags": [
        "attic",
        "advanTech"
      ],
      "confidence": 96,
      "thumb": "C6WqnwxRU3c_cover.jpg",
      "media": [
        "C6WqnwxRU3c.mp4"
      ],
      "files": [
        "C6WqnwxRU3c.mp4",
        "C6WqnwxRU3c_cover.jpg"
      ]
    },
    {
      "id": "C6ryWONx7uL",
      "category": "finished-structure",
      "slug": "window-porch-view",
      "format": "still",
      "orientation": "square",
      "description": "Interior view out finished window to porch",
      "tags": [
        "window",
        "interior"
      ],
      "confidence": 92,
      "thumb": "C6ryWONx7uL.jpg",
      "media": [
        "C6ryWONx7uL.jpg"
      ],
      "files": [
        "C6ryWONx7uL.jpg"
      ]
    },
    {
      "id": "C8MuhAFgbg0",
      "category": "marketing-graphics",
      "slug": "process-timeline-infographic",
      "format": "still",
      "orientation": "landscape",
      "description": "Construx process timeline Design Manufacture Transport Assemble",
      "tags": [
        "infographic",
        "timeline"
      ],
      "confidence": 99,
      "thumb": "C8MuhAFgbg0.jpg",
      "media": [
        "C8MuhAFgbg0.jpg"
      ],
      "files": [
        "C8MuhAFgbg0.jpg"
      ]
    },
    {
      "id": "C8ZxtoCgLPa",
      "category": "assembly-guides",
      "slug": "sr9-super-ring-guide",
      "format": "gallery",
      "orientation": "portrait",
      "description": "SR9 Super Ring Construction Guide on Adams House site",
      "tags": [
        "guide",
        "gallery",
        "sr9"
      ],
      "confidence": 98,
      "thumb": "C8ZxtoCgLPa_1.jpg",
      "media": [
        "C8ZxtoCgLPa_1.jpg",
        "C8ZxtoCgLPa_2.jpg",
        "C8ZxtoCgLPa_3.jpg",
        "C8ZxtoCgLPa_4.jpg"
      ],
      "files": [
        "C8ZxtoCgLPa_1.jpg",
        "C8ZxtoCgLPa_2.jpg",
        "C8ZxtoCgLPa_3.jpg",
        "C8ZxtoCgLPa_4.jpg"
      ]
    },
    {
      "id": "C8sIKeqpXIs",
      "category": "factory-shop",
      "slug": "life-size-lego-sealant",
      "format": "video",
      "orientation": "vertical",
      "description": "Life Size Lego OSB block with foam sealant in shop",
      "tags": [
        "lego-metaphor",
        "osb",
        "social-caption"
      ],
      "confidence": 98,
      "thumb": "C8sIKeqpXIs_cover.jpg",
      "media": [
        "C8sIKeqpXIs.mp4"
      ],
      "files": [
        "C8sIKeqpXIs.mp4",
        "C8sIKeqpXIs_cover.jpg"
      ]
    },
    {
      "id": "C8wtXuhRpIj",
      "category": "factory-shop",
      "slug": "shop-floor-crew",
      "format": "video",
      "orientation": "vertical",
      "description": "Crew assembling on warehouse concrete floor",
      "tags": [
        "crew",
        "shop"
      ],
      "confidence": 93,
      "thumb": "C8wtXuhRpIj_cover.jpg",
      "media": [
        "C8wtXuhRpIj.mp4"
      ],
      "files": [
        "C8wtXuhRpIj.mp4",
        "C8wtXuhRpIj_cover.jpg"
      ]
    },
    {
      "id": "C98L8n8S2_6",
      "category": "press-events",
      "slug": "fox-news-dusk-booth-build",
      "format": "video",
      "orientation": "vertical",
      "description": "Dusk Construx booth build at Fox News plaza",
      "tags": [
        "fox-news",
        "booth"
      ],
      "confidence": 96,
      "thumb": "C98L8n8S2_6_cover.jpg",
      "media": [
        "C98L8n8S2_6.mp4"
      ],
      "files": [
        "C98L8n8S2_6.mp4",
        "C98L8n8S2_6_cover.jpg"
      ]
    },
    {
      "id": "C9QVWfRSmAw",
      "category": "jobsite-framing",
      "slug": "osb-sheathed-exterior-corner",
      "format": "still",
      "orientation": "square",
      "description": "AdvanTech OSB sheathed house corner exterior",
      "tags": [
        "sheathing",
        "advanTech"
      ],
      "confidence": 97,
      "thumb": "C9QVWfRSmAw.jpg",
      "media": [
        "C9QVWfRSmAw.jpg"
      ],
      "files": [
        "C9QVWfRSmAw.jpg"
      ]
    },
    {
      "id": "C_9gpLGR8ck",
      "category": "stock-broll",
      "slug": "barn-interior-hay",
      "format": "video",
      "orientation": "vertical",
      "description": "Rustic barn interior with hay bales",
      "tags": [
        "barn",
        "stock"
      ],
      "confidence": 95,
      "thumb": "C_9gpLGR8ck_cover.jpg",
      "media": [
        "C_9gpLGR8ck.mp4"
      ],
      "files": [
        "C_9gpLGR8ck.mp4",
        "C_9gpLGR8ck_cover.jpg"
      ]
    },
    {
      "id": "C_WlCrlgxjq",
      "category": "jobsite-framing",
      "slug": "construx-logo-on-osb-wall",
      "format": "video",
      "orientation": "vertical",
      "description": "Large construx wordmark printed on OSB wall",
      "tags": [
        "branding",
        "osb",
        "advanTech"
      ],
      "confidence": 98,
      "thumb": "C_WlCrlgxjq_cover.jpg",
      "media": [
        "C_WlCrlgxjq.mp4"
      ],
      "files": [
        "C_WlCrlgxjq.mp4",
        "C_WlCrlgxjq_cover.jpg"
      ]
    },
    {
      "id": "C_dJw1DxTyO",
      "category": "site-context",
      "slug": "backyard-spanish-moss",
      "format": "video",
      "orientation": "vertical",
      "description": "Backyard path with Spanish moss trees",
      "tags": [
        "landscape",
        "south"
      ],
      "confidence": 94,
      "thumb": "C_dJw1DxTyO_cover.jpg",
      "media": [
        "C_dJw1DxTyO.mp4"
      ],
      "files": [
        "C_dJw1DxTyO.mp4",
        "C_dJw1DxTyO_cover.jpg"
      ]
    },
    {
      "id": "CuBI1JcpRpT",
      "category": "jobsite-framing",
      "slug": "osb-stair-kit-stc",
      "format": "video",
      "orientation": "vertical",
      "description": "Prefabricated OSB stairs STC101/102 with hammer",
      "tags": [
        "stairs",
        "advanTech"
      ],
      "confidence": 97,
      "thumb": "CuBI1JcpRpT_cover.jpg",
      "media": [
        "CuBI1JcpRpT.mp4"
      ],
      "files": [
        "CuBI1JcpRpT.mp4",
        "CuBI1JcpRpT_cover.jpg"
      ]
    },
    {
      "id": "CwRMz_8trsQ",
      "category": "factory-shop",
      "slug": "scale-847kg",
      "format": "video",
      "orientation": "vertical",
      "description": "Weigh South WS10 scale reading 847 kg",
      "tags": [
        "qc",
        "weight"
      ],
      "confidence": 96,
      "thumb": "CwRMz_8trsQ_cover.jpg",
      "media": [
        "CwRMz_8trsQ.mp4"
      ],
      "files": [
        "CwRMz_8trsQ.mp4",
        "CwRMz_8trsQ_cover.jpg"
      ]
    },
    {
      "id": "Cx26youunY6",
      "category": "brand-logo",
      "slug": "logo-on-white",
      "format": "video",
      "orientation": "vertical",
      "description": "Construx logo centered on white field",
      "tags": [
        "logo"
      ],
      "confidence": 99,
      "thumb": "Cx26youunY6_cover.jpg",
      "media": [
        "Cx26youunY6.mp4"
      ],
      "files": [
        "Cx26youunY6.mp4",
        "Cx26youunY6_cover.jpg"
      ]
    },
    {
      "id": "Cx9dtyJuhw2",
      "category": "jobsite-framing",
      "slug": "worker-scaffold-open-framing",
      "format": "video",
      "orientation": "vertical",
      "description": "Worker on yellow scaffold in open framing",
      "tags": [
        "scaffold",
        "worker"
      ],
      "confidence": 96,
      "thumb": "Cx9dtyJuhw2_cover.jpg",
      "media": [
        "Cx9dtyJuhw2.mp4"
      ],
      "files": [
        "Cx9dtyJuhw2.mp4",
        "Cx9dtyJuhw2_cover.jpg"
      ]
    },
    {
      "id": "DAJ6NIOywIv",
      "category": "jobsite-framing",
      "slug": "waffle-panel-interior-stairs",
      "format": "video",
      "orientation": "vertical",
      "description": "Waffle-cut OSB panel interior with stairs",
      "tags": [
        "waffle-panel",
        "interior"
      ],
      "confidence": 97,
      "thumb": "DAJ6NIOywIv_cover.jpg",
      "media": [
        "DAJ6NIOywIv.mp4"
      ],
      "files": [
        "DAJ6NIOywIv.mp4",
        "DAJ6NIOywIv_cover.jpg"
      ]
    },
    {
      "id": "DB6QYL4JZMf",
      "category": "people-spokesperson",
      "slug": "selfie-at-two-story-framing",
      "format": "video",
      "orientation": "vertical",
      "description": "Spokesperson selfie in front of two-story framing",
      "tags": [
        "selfie",
        "spokesperson"
      ],
      "confidence": 95,
      "thumb": "DB6QYL4JZMf_cover.jpg",
      "media": [
        "DB6QYL4JZMf.mp4"
      ],
      "files": [
        "DB6QYL4JZMf.mp4",
        "DB6QYL4JZMf_cover.jpg"
      ]
    },
    {
      "id": "DB834eFp1fo",
      "category": "people-spokesperson",
      "slug": "selfie-cleared-land-teardrops",
      "format": "video",
      "orientation": "vertical",
      "description": "Spokesperson selfie on cleared land Tear Drops NW shirt",
      "tags": [
        "selfie",
        "site"
      ],
      "confidence": 92,
      "thumb": "DB834eFp1fo_cover.jpg",
      "media": [
        "DB834eFp1fo.mp4"
      ],
      "files": [
        "DB834eFp1fo.mp4",
        "DB834eFp1fo_cover.jpg"
      ]
    },
    {
      "id": "DB9z-gcSWKA",
      "category": "jobsite-framing",
      "slug": "two-story-osb-cabin-shell",
      "format": "video",
      "orientation": "vertical",
      "description": "Two-story OSB cabin shell with plank ramp",
      "tags": [
        "shell",
        "cabin"
      ],
      "confidence": 96,
      "thumb": "DB9z-gcSWKA_cover.jpg",
      "media": [
        "DB9z-gcSWKA.mp4"
      ],
      "files": [
        "DB9z-gcSWKA.mp4",
        "DB9z-gcSWKA_cover.jpg"
      ]
    },
    {
      "id": "DBpbSlEtHKV",
      "category": "people-spokesperson",
      "slug": "selfie-weathered-building",
      "format": "video",
      "orientation": "vertical",
      "description": "Spokesperson selfie at weathered white building",
      "tags": [
        "selfie"
      ],
      "confidence": 93,
      "thumb": "DBpbSlEtHKV_cover.jpg",
      "media": [
        "DBpbSlEtHKV.mp4"
      ],
      "files": [
        "DBpbSlEtHKV.mp4",
        "DBpbSlEtHKV_cover.jpg"
      ]
    },
    {
      "id": "DCC3X8rSlhw",
      "category": "people-spokesperson",
      "slug": "thank-you-diamondkote-operation-anchor",
      "format": "video",
      "orientation": "vertical",
      "description": "Thank you @diamondkote @operation anchor NC Mountains",
      "tags": [
        "social-caption",
        "partners",
        "disaster-relief"
      ],
      "confidence": 97,
      "thumb": "DCC3X8rSlhw_cover.jpg",
      "media": [
        "DCC3X8rSlhw.mp4"
      ],
      "files": [
        "DCC3X8rSlhw.mp4",
        "DCC3X8rSlhw_cover.jpg"
      ]
    },
    {
      "id": "DCmENltTp6D",
      "category": "marketing-graphics",
      "slug": "offsitedirt-hybrid-approach",
      "format": "still",
      "orientation": "square",
      "description": "OffSiteDirt hybrid approach before/after graphic",
      "tags": [
        "press",
        "blog"
      ],
      "confidence": 98,
      "thumb": "DCmENltTp6D.jpg",
      "media": [
        "DCmENltTp6D.jpg"
      ],
      "files": [
        "DCmENltTp6D.jpg"
      ]
    },
    {
      "id": "DDlElwLpXqX",
      "category": "finished-structure",
      "slug": "white-cabin-near-complete",
      "format": "video",
      "orientation": "vertical",
      "description": "Nearly finished white cabin with Construx hoodie",
      "tags": [
        "cabin",
        "siding"
      ],
      "confidence": 94,
      "thumb": "DDlElwLpXqX_cover.jpg",
      "media": [
        "DDlElwLpXqX.mp4"
      ],
      "files": [
        "DDlElwLpXqX.mp4",
        "DDlElwLpXqX_cover.jpg"
      ]
    },
    {
      "id": "DEX5Fwtprpa",
      "category": "site-context",
      "slug": "relief-sign",
      "format": "video",
      "orientation": "vertical",
      "description": "Green RELIEF sign at weathered building",
      "tags": [
        "disaster-relief",
        "signage"
      ],
      "confidence": 96,
      "thumb": "DEX5Fwtprpa_cover.jpg",
      "media": [
        "DEX5Fwtprpa.mp4"
      ],
      "files": [
        "DEX5Fwtprpa.mp4",
        "DEX5Fwtprpa_cover.jpg"
      ]
    },
    {
      "id": "DEqPqXVpPgr",
      "category": "jobsite-framing",
      "slug": "slab-beams-material-staging",
      "format": "gallery",
      "orientation": "landscape",
      "description": "Slab site with engineered beams and material staging",
      "tags": [
        "gallery",
        "slab",
        "lvl"
      ],
      "confidence": 95,
      "thumb": "DEqPqXVpPgr_1.jpg",
      "media": [
        "DEqPqXVpPgr_1.jpg",
        "DEqPqXVpPgr_2.jpg",
        "DEqPqXVpPgr_3.jpg",
        "DEqPqXVpPgr_4.jpg",
        "DEqPqXVpPgr_5.jpg",
        "DEqPqXVpPgr_6.jpg",
        "DEqPqXVpPgr_7.jpg",
        "DEqPqXVpPgr_8.jpg"
      ],
      "files": [
        "DEqPqXVpPgr_1.jpg",
        "DEqPqXVpPgr_2.jpg",
        "DEqPqXVpPgr_3.jpg",
        "DEqPqXVpPgr_4.jpg",
        "DEqPqXVpPgr_5.jpg",
        "DEqPqXVpPgr_6.jpg",
        "DEqPqXVpPgr_7.jpg",
        "DEqPqXVpPgr_8.jpg"
      ]
    },
    {
      "id": "DHCYS4JgZK4",
      "category": "jobsite-framing",
      "slug": "cabin-framing-muddy-site",
      "format": "gallery",
      "orientation": "portrait",
      "description": "Cabin framing progress on muddy rural site",
      "tags": [
        "gallery",
        "cabin"
      ],
      "confidence": 95,
      "thumb": "DHCYS4JgZK4_1.jpg",
      "media": [
        "DHCYS4JgZK4_1.jpg",
        "DHCYS4JgZK4_2.jpg",
        "DHCYS4JgZK4_3.jpg",
        "DHCYS4JgZK4_4.jpg",
        "DHCYS4JgZK4_5.jpg",
        "DHCYS4JgZK4_6.jpg",
        "DHCYS4JgZK4_7.jpg"
      ],
      "files": [
        "DHCYS4JgZK4_1.jpg",
        "DHCYS4JgZK4_2.jpg",
        "DHCYS4JgZK4_3.jpg",
        "DHCYS4JgZK4_4.jpg",
        "DHCYS4JgZK4_5.jpg",
        "DHCYS4JgZK4_6.jpg",
        "DHCYS4JgZK4_7.jpg"
      ]
    },
    {
      "id": "DN020C83NTx",
      "category": "product-renders",
      "slug": "construx-toy-truck-blocks",
      "format": "video",
      "orientation": "vertical",
      "description": "Toy flatbed truck loaded with Construx blocks metaphor",
      "tags": [
        "toy-metaphor",
        "lego"
      ],
      "confidence": 94,
      "thumb": "DN020C83NTx_cover.jpg",
      "media": [
        "DN020C83NTx.mp4"
      ],
      "files": [
        "DN020C83NTx.mp4",
        "DN020C83NTx_cover.jpg"
      ]
    },
    {
      "id": "DN0c03F3FzZ",
      "category": "product-renders",
      "slug": "block-piers-model",
      "format": "video",
      "orientation": "square",
      "description": "Block house model on piers labeled Block piers",
      "tags": [
        "cgi",
        "foundation",
        "metaphor"
      ],
      "confidence": 97,
      "thumb": "DN0c03F3FzZ_cover.jpg",
      "media": [
        "DN0c03F3FzZ.mp4"
      ],
      "files": [
        "DN0c03F3FzZ.mp4",
        "DN0c03F3FzZ_cover.jpg"
      ]
    },
    {
      "id": "DN1muar3ksV",
      "category": "product-renders",
      "slug": "interlocking-beam-component",
      "format": "video",
      "orientation": "landscape",
      "description": "Single interlocking beam component product shot",
      "tags": [
        "cgi",
        "component"
      ],
      "confidence": 98,
      "thumb": "DN1muar3ksV_cover.jpg",
      "media": [
        "DN1muar3ksV.mp4"
      ],
      "files": [
        "DN1muar3ksV.mp4",
        "DN1muar3ksV_cover.jpg"
      ]
    },
    {
      "id": "DN1n65_XgfG",
      "category": "product-renders",
      "slug": "model-b7a-side-d",
      "format": "video",
      "orientation": "landscape",
      "description": "3D model B7A Side D panelized structure",
      "tags": [
        "cgi",
        "model-b7a"
      ],
      "confidence": 98,
      "thumb": "DN1n65_XgfG_cover.jpg",
      "media": [
        "DN1n65_XgfG.mp4"
      ],
      "files": [
        "DN1n65_XgfG.mp4",
        "DN1n65_XgfG_cover.jpg"
      ]
    },
    {
      "id": "DN1nk4VXj1q",
      "category": "product-renders",
      "slug": "foundation-platform",
      "format": "video",
      "orientation": "landscape",
      "description": "Dark foundation platform baseplate with tabs",
      "tags": [
        "cgi",
        "foundation"
      ],
      "confidence": 97,
      "thumb": "DN1nk4VXj1q_cover.jpg",
      "media": [
        "DN1nk4VXj1q.mp4"
      ],
      "files": [
        "DN1nk4VXj1q.mp4",
        "DN1nk4VXj1q_cover.jpg"
      ]
    },
    {
      "id": "DNgT7JzgZE2",
      "category": "panel-assembly",
      "slug": "crane-erecting-gable",
      "format": "video",
      "orientation": "square",
      "description": "Crew/crane erecting timber gable on platform",
      "tags": [
        "crane",
        "gable"
      ],
      "confidence": 96,
      "thumb": "DNgT7JzgZE2_cover.jpg",
      "media": [
        "DNgT7JzgZE2.mp4"
      ],
      "files": [
        "DNgT7JzgZE2.mp4",
        "DNgT7JzgZE2_cover.jpg"
      ]
    },
    {
      "id": "DNoy2oFvyzQ",
      "category": "people-spokesperson",
      "slug": "worker-talking-head-framing",
      "format": "video",
      "orientation": "vertical",
      "description": "Worker in orange talking inside framed room",
      "tags": [
        "talking-head",
        "jobsite"
      ],
      "confidence": 95,
      "thumb": "DNoy2oFvyzQ_cover.jpg",
      "media": [
        "DNoy2oFvyzQ.mp4"
      ],
      "files": [
        "DNoy2oFvyzQ.mp4",
        "DNoy2oFvyzQ_cover.jpg"
      ]
    },
    {
      "id": "DNv_QyAXpzJ",
      "category": "people-spokesperson",
      "slug": "connector-piece-demo",
      "format": "video",
      "orientation": "vertical",
      "description": "Branded merch holding interlocking connector sample",
      "tags": [
        "connector",
        "merch"
      ],
      "confidence": 97,
      "thumb": "DNv_QyAXpzJ_cover.jpg",
      "media": [
        "DNv_QyAXpzJ.mp4"
      ],
      "files": [
        "DNv_QyAXpzJ.mp4",
        "DNv_QyAXpzJ_cover.jpg"
      ]
    },
    {
      "id": "DNxgaX-XDoE",
      "category": "assembly-guides",
      "slug": "the-plans-elevation",
      "format": "video",
      "orientation": "vertical",
      "description": "The plans part-numbered outside elevation drawing",
      "tags": [
        "plans",
        "parts",
        "social-caption"
      ],
      "confidence": 98,
      "thumb": "DNxgaX-XDoE_cover.jpg",
      "media": [
        "DNxgaX-XDoE.mp4"
      ],
      "files": [
        "DNxgaX-XDoE.mp4",
        "DNxgaX-XDoE_cover.jpg"
      ]
    },
    {
      "id": "DNyjWGj3ude",
      "category": "jobsite-framing",
      "slug": "the-shell-interior",
      "format": "video",
      "orientation": "vertical",
      "description": "The shell waffle-panel interior under construction",
      "tags": [
        "shell",
        "waffle-panel",
        "social-caption"
      ],
      "confidence": 98,
      "thumb": "DNyjWGj3ude_cover.jpg",
      "media": [
        "DNyjWGj3ude.mp4"
      ],
      "files": [
        "DNyjWGj3ude.mp4",
        "DNyjWGj3ude_cover.jpg"
      ]
    },
    {
      "id": "DON5-_YDldR",
      "category": "jobsite-framing",
      "slug": "before-sheathing-housewrap",
      "format": "video",
      "orientation": "vertical",
      "description": "Before overlay on sheathed/housewrapped gable",
      "tags": [
        "before-after",
        "housewrap",
        "social-caption"
      ],
      "confidence": 96,
      "thumb": "DON5-_YDldR_cover.jpg",
      "media": [
        "DON5-_YDldR.mp4"
      ],
      "files": [
        "DON5-_YDldR.mp4",
        "DON5-_YDldR_cover.jpg"
      ]
    },
    {
      "id": "DON63crDmGS",
      "category": "jobsite-framing",
      "slug": "hvac-plenum-rough-in",
      "format": "video",
      "orientation": "vertical",
      "description": "Galvanized HVAC plenum/register box rough-in",
      "tags": [
        "hvac",
        "mechanical"
      ],
      "confidence": 95,
      "thumb": "DON63crDmGS_cover.jpg",
      "media": [
        "DON63crDmGS.mp4"
      ],
      "files": [
        "DON63crDmGS.mp4",
        "DON63crDmGS_cover.jpg"
      ]
    },
    {
      "id": "DOZu6XakYti",
      "category": "product-renders",
      "slug": "rings-technical-drawing",
      "format": "video",
      "orientation": "vertical",
      "description": "Rings technical isometric bay frame drawing",
      "tags": [
        "cad",
        "rings",
        "er1"
      ],
      "confidence": 97,
      "thumb": "DOZu6XakYti_cover.jpg",
      "media": [
        "DOZu6XakYti.mp4"
      ],
      "files": [
        "DOZu6XakYti.mp4",
        "DOZu6XakYti_cover.jpg"
      ]
    },
    {
      "id": "DOeXCGpDzpj",
      "category": "product-renders",
      "slug": "model-f1ae-finished",
      "format": "video",
      "orientation": "vertical",
      "description": "F1AE finished model 2bed/2bath/640sqft card",
      "tags": [
        "model-f1ae",
        "specs"
      ],
      "confidence": 99,
      "thumb": "DOeXCGpDzpj_cover.jpg",
      "media": [
        "DOeXCGpDzpj.mp4"
      ],
      "files": [
        "DOeXCGpDzpj.mp4",
        "DOeXCGpDzpj_cover.jpg"
      ]
    },
    {
      "id": "DOnxdOwDkD3",
      "category": "marketing-graphics",
      "slug": "simplicity-at-its-best",
      "format": "video",
      "orientation": "vertical",
      "description": "Simplicity at its best panel marketing slide",
      "tags": [
        "slogan",
        "panel"
      ],
      "confidence": 98,
      "thumb": "DOnxdOwDkD3_cover.jpg",
      "media": [
        "DOnxdOwDkD3.mp4"
      ],
      "files": [
        "DOnxdOwDkD3.mp4",
        "DOnxdOwDkD3_cover.jpg"
      ]
    },
    {
      "id": "DOnynbajjbS",
      "category": "product-renders",
      "slug": "parts-sprite-atlas",
      "format": "video",
      "orientation": "square",
      "description": "Pixelated parts/sprite atlas of system components",
      "tags": [
        "parts",
        "atlas"
      ],
      "confidence": 90,
      "thumb": "DOnynbajjbS_cover.jpg",
      "media": [
        "DOnynbajjbS.mp4"
      ],
      "files": [
        "DOnynbajjbS.mp4",
        "DOnynbajjbS_cover.jpg"
      ]
    },
    {
      "id": "DVCwVk6Abdi",
      "category": "press-events",
      "slug": "spider-lath-trade-show",
      "format": "video",
      "orientation": "landscape",
      "description": "Trade-show segment Construx wall with Spider Lath",
      "tags": [
        "trade-show",
        "spider-lath"
      ],
      "confidence": 97,
      "thumb": "DVCwVk6Abdi_cover.jpg",
      "media": [
        "DVCwVk6Abdi.mp4"
      ],
      "files": [
        "DVCwVk6Abdi.mp4",
        "DVCwVk6Abdi_cover.jpg"
      ]
    },
    {
      "id": "DVgv95kAb_7",
      "category": "panel-assembly",
      "slug": "crane-placing-roof-truss",
      "format": "video",
      "orientation": "landscape",
      "description": "Crane placing roof truss on modular wall boxes",
      "tags": [
        "crane",
        "truss"
      ],
      "confidence": 97,
      "thumb": "DVgv95kAb_7_cover.jpg",
      "media": [
        "DVgv95kAb_7.mp4"
      ],
      "files": [
        "DVgv95kAb_7.mp4",
        "DVgv95kAb_7_cover.jpg"
      ]
    },
    {
      "id": "DVqepihFQ8n",
      "category": "product-renders",
      "slug": "wireframe-house-gallery",
      "format": "gallery",
      "orientation": "landscape",
      "description": "CAD wireframe panelized house model views",
      "tags": [
        "gallery",
        "cad",
        "wireframe"
      ],
      "confidence": 97,
      "thumb": "DVqepihFQ8n_1.jpg",
      "media": [
        "DVqepihFQ8n_1.jpg",
        "DVqepihFQ8n_2.jpg",
        "DVqepihFQ8n_3.jpg",
        "DVqepihFQ8n_4.jpg"
      ],
      "files": [
        "DVqepihFQ8n_1.jpg",
        "DVqepihFQ8n_2.jpg",
        "DVqepihFQ8n_3.jpg",
        "DVqepihFQ8n_4.jpg"
      ]
    },
    {
      "id": "DVra4xxj7B-",
      "category": "marketing-graphics",
      "slug": "better-stronger-faster-promo",
      "format": "video",
      "orientation": "vertical",
      "description": "Better stronger faster CONSTRUX trade-show promo",
      "tags": [
        "slogan",
        "trade-show"
      ],
      "confidence": 98,
      "thumb": "DVra4xxj7B-_cover.jpg",
      "media": [
        "DVra4xxj7B-.mp4"
      ],
      "files": [
        "DVra4xxj7B-.mp4",
        "DVra4xxj7B-_cover.jpg"
      ]
    }
  ]
};

export default buildconstruxCatalog;
